/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class SubjectRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    let store = this.store;

    return hash({
      subject: store.findRecord('goals/subject', params.subject_id),
      categories: store.query('goals/category', {
        subjectId: params.subject_id,
      }),
      subcategories: store.query('goals/subcategory', {
        subjectId: params.subject_id,
      }),
      goals: store.query('goals/goal', { subjectId: params.subject_id }),
      schools: store.findAll('school'),
    });
  }
}
